import { HalfMoonIcon } from '@synoptic/ui-kit/icons/react/half-moon.js';
import { useIsLaptop } from '@synoptic/ui-kit/responsive/hooks.js';
import { Switch } from '@synoptic/ui-kit/switch/switch.js';
import {
  useThemeMode,
  useThemeSwitch,
} from '@synoptic/ui-kit/theme/theme-context.js';
import clsx from 'clsx';
import { useSidebarContext } from './sidebar-context';
import { menuItemLink } from './menu/menu-action/menu-action.css';
import { profileMenuItem, profileMenuSwitch } from './profile-menu.css';

export const DarkModeToggle = () => {
  const theme = useThemeMode();
  const switchTheme = useThemeSwitch();
  const isLaptop = useIsLaptop();

  const { isCollapsed } = useSidebarContext();

  return (
    <label className={clsx(menuItemLink, profileMenuItem)}>
      <HalfMoonIcon />
      Dark mode
      <Switch
        style={isCollapsed || !isLaptop ? { display: 'none' } : {}}
        className={profileMenuSwitch}
        checked={theme === 'dark'}
        onCheckedChange={(checked) => {
          switchTheme(checked ? 'dark' : 'light');
        }}
      />
    </label>
  );
};
